import { render, staticRenderFns } from "./AcademyRules.vue?vue&type=template&id=9d7a73e6&scoped=true"
import script from "./AcademyRules.vue?vue&type=script&lang=js"
export * from "./AcademyRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7a73e6",
  null
  
)

export default component.exports